module.exports = __webpack_public_path__ + "img/Gold_Mammoth_Miami_Glenford_Nunez.66861473.jpeg";